import React from 'react';
import InternalBar from "../../TopLayout/InternalBar/InternalBar";
import {useHistory} from "react-router-dom";
import './TaskCardComplete.css';
import performers from '../../../../../assets/images/completeTaskEarnPoint-2026.png'
import CardButton from '../CardButton/CardButton';
import { directDeepLink, SOURCE_HOME } from '../../../util';
import { tutor_of_the_day, view_all_tasks } from '../../../../../cosmosTracking/cosmosEvents';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';

function CompleteTaskWin({cards,dataRedirection ={}, scrollNav=()=>{}}) {
    const history = useHistory();
    const filteredItem = Array.isArray(cards) ? cards.slice(0, 2).filter((item) => !item?.isComplete) : [];
    console.log("aaa",dataRedirection);
    const handleClick = ()=>{
        const pp = dataRedirection?.deeplink;
        cosmosTrackService(view_all_tasks)
        pp && directDeepLink(pp, SOURCE_HOME);
    }
    return (
        <div className="slideCard taskCard-win">
            <div className="cardBody">
                <img className="leader-board-top-img" src={performers} alt="title"/>
                <hr className='leader-board-top-img-border' />
                    <div className="task-card-mini-containers">
                
                        {filteredItem?.map((item, index) => (
                            <div className="task-card-minis" key={index}>
                                <h3>
                                    {item?.task || "Task Name"}
                                    <img
                                        src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/card-forward-white-icon26.png"
                                        alt="overview card forward"
                                        height={12}
                                    />
                                </h3>
                                {item?.statType === 3 ? (
                                    <p>{item?.completedText || "Completed Text"}</p>
                                ) : (
                                    <p>
                                        {item?.total || 0} {item?.completedText || ""}
                                    </p>
                                )}
                                <InternalBar height={12} width={item?.percentage || 20} />
                            </div>
                        ))}
                        
                    </div>
                     <button className="btn-action" onClick={handleClick}>
                            View All Tasks
                        </button>
                    {/* <CardButton text={'View All Tasks'}
							deeplink={dataRedirection?.deeplink}
							className={'btn-action'}
							eventCallback={() => {
								// cosmosTrackService(view_overview)
							}}>
				</CardButton> */}
                   
                </div>
        </div>
    );
    
}

export default CompleteTaskWin;
